import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

function UserGuide() {
  return (
    <section>
      <Container className="px-0">
        <Row className="no-gutters">
          <Col sm="12">
            <div className="privacy-policy-wrapper my-5">
              <div className="heading mb-4 text-uppercase text-center my-5">
                Software User Guide
              </div>

              <div className="sub-head fw-bold my-4">Introduction</div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                This software user guide provides step-by-step instructions on
                how to use the commercial permit application portal for the
                Village of Pingree Grove. This manual is designed to help users
                navigate the system efficiently. Lakeside Consultants™ owns
                Simplepermit™ software and is permitting the Village to utilize
                a customized version.
              </p>

              <div className="sub-head fw-bold my-4">Table of Contents</div>
              <ol className="mb-4" style={{ textAlign: "justify" }}>
                <li>
                  <a href="#accessing-portal">Accessing Portal</a>
                </li>
                <li>
                  <a href="#troubleshooting">Troubleshooting</a>
                </li>
                <li>
                  <a href="#contact-information">Contact Information</a>
                </li>
                <li>
                  <a href="#faqs">FAQs</a>
                </li>
                <li>
                  <a href="#commercial-permit-definitions">
                    Commercial Permit Definitions
                  </a>
                </li>
                <li>
                  <a href="#permit-application-process">
                    Permit Application Process
                  </a>
                </li>
              </ol>

              <div
                id="accessing-portal"
                className="sub-head fw-bold my-4"
              >
                1. Accessing Portal
              </div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                The system is cloud-based and accessible from any internet-enabled device.
              </p>

              <div id="troubleshooting" className="sub-head fw-bold my-4">2. Troubleshooting</div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                If you have any questions or issues with the software functions, please see contact information below.
              </p>

              <div id="contact-information" className="sub-head fw-bold my-4">3. Contact Information</div>
              <p className="mb-2" style={{ textAlign: "justify" }}>
                Email:{" "}
                <a href="mailto:info@simplepermit.io">info@simplepermit.io</a>{" "}
                Phone:{" "}
                <a href="tel:13312749630">331-274-9630</a>{" "}
                Web form:{" "}
                <a
                  href="https://lakesideconsultants.net/contact/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://lakesideconsultants.net/contact/
                </a>
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                LinkedIn:{" "}
                <a
                  href="https://www.linkedin.com/company/lakeside-consultants-code-services"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/company/lakeside-consultants-code-services
                </a>
              </p>

              <div id="faqs" className="sub-head fw-bold my-4">4. FAQs</div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>Is your product safe and reliable?</strong> Yes, our technology product was designed by a regulatory professional. Additionally, we own and manage our software and handle all customer service locally.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>Is my information secure?</strong> Yes, your information is submitted through our secure website, and we never share, sell, or retain your information beyond what is required for processing your permit.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>How do I pay for my permit?</strong> Payment for your
                commercial building permit is split into two parts. First,
                payment made to Lakeside Consultants is required prior to the
                completion of your plan review. After a permit is submitted,
                Lakeside Consultants will reach out with the total cost for the
                plan review. Once the applicant has paid for the plan review, it
                will commence. Once the plan review is completed, an invoice
                including permit(s) and inspection(s) fees will be provided to
                the applicant. The applicant is required to pay the invoice to
                the Village of Pingree Grove. Payments to the Village of
                Pingree Grove can be made in person via cash or check, or,
                online through the Village's portal, linked here:{" "}
                <a
                  href="https://client.pointandpay.net/web/villageofpingreegrove"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://client.pointandpay.net/web/villageofpingreegrove
                </a>
                . If the permit(s) and inspection(s) fees are paid through the
                Village's portal, forward your payment confirmation email to
                Lakeside with your permit number and address identification in
                the email.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>
                  How do I submit and pay for fire-related documents for review
                  and schedule inspections for those items?
                </strong>{" "}
                Fire-related plan reviews and inspections are handled in tandem
                with the Pingree Grove Fire Protection District. Fire-related
                plans, such as fire suppression or fire alarm systems, should
                still be uploaded via Simplepermit with the other necessary
                building documents. Lakeside Consultants will coordinate with
                the Fire District on the plan review process, and from there,
                the applicant will be contacted by the Fire Protection District
                as needed. Depending on the project, the Fire Protection
                District may request physical plans; if this is the case, they
                will contact the applicant.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                To pay for fire plan reviews and other relevant work, please
                write a check, made out to the Pingree Grove Fire Protection
                District, and mail it to 10N255 Dittman Road, Elgin, IL 60124.
                The Pingree Grove Fire Protection District’s Plan Review Fee
                Schedule can be viewed online at{" "}
                <a
                  href="https://villageofpingreegrove.org/152/Building-Department"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://villageofpingreegrove.org/152/Building-Department
                </a>
                .
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>How do I schedule fire-related inspections?</strong> To
                request an inspection for fire suppression, fire alarm, or
                sprinkler systems, please contact the Pingree Grove Fire
                Protection District at{" "}
                <a href="mailto:fire.prevention@pgfpd.com">
                  fire.prevention@pgfpd.com
                </a>{" "}
                or call{" "}
                <a href="tel:18477413151">847-741-3151</a>. Inspections are
                provided within 72-hours of the request.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                <strong>How long will it take for me to receive my building permit?</strong> Typically, plan reviews are completed within 10 business days.
              </p>

              <div
                id="commercial-permit-definitions"
                className="sub-head fw-bold my-4"
              >
                5. Commercial Permit Definitions
              </div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Below are the types of commercial building permits within
                Pingree Grove, along with examples of each. The listed examples
                are not comprehensive of all work that would qualify for the
                respective permit type. If you have questions about what permit
                needs to be pulled for your project, please contact Lakeside
                Consultants at{" "}
                <a href="mailto:info@simplepermit.io">info@simplepermit.io</a>.
              </p>
              <ul className="mb-4" style={{ textAlign: "justify" }}>
                <li>
                  <strong>New Construction:</strong> Projects that include a new foundation. (a new building)
                </li>
                <li>
                  <strong>Exterior Remodel:</strong> Projects that include new work or replacement on the exterior surface of the existing building. (replacing exterior facade, replacing exterior windows, renovating a parking lot)
                </li>
                <li>
                  <strong>Interior Remodel:</strong> Projects that include remodeling or replacement of interior finishes or components, including electric, plumbing, and mechanical. (replacing drop ceilings with new framing, tenant build-outs)
                </li>
                <li>
                  <strong>Building Work Only (Non-Structural):</strong> Projects
                  not defined elsewhere that do not affect structural elements.
                  (removing or altering a non-load-bearing wall, replacing
                  windows or doorframes of the same size and location)
                </li>
                <li>
                  <strong>Building Work Only (Structural):</strong> Projects not
                  defined that include a letter or plans from a design
                  professional or are structural in nature. (removing or
                  altering a load-bearing wall, pouring or altering concrete
                  foundation)
                </li>
                <li>
                  <strong>Electric Only:</strong> Projects that include new work, replacement, or repairs of electric systems or components only. (adding or upgrading site lighting poles or fixtures in a parking lot, installing a new service feed to a building, or installing a new transformer)
                </li>
                <li>
                  <strong>Mechanical Only:</strong> Projects that include new work, replacement, or repairs of mechanical systems or components only. (installation of a furnace, installation or alteration of a combustion air duct)
                </li>
                <li>
                  <strong>Plumbing Only:</strong> Projects that include new work, replacement, or repairs of plumbing systems or components only. (installation or replacement of a water service, backflow prevention device, sump pump or ejector pump)
                </li>
                <li>
                  <strong>Sign Only:</strong> Any proposed wall or ground sign. (installation of a monument sign, illuminated sign, or wall sign)
                </li>
              </ul>

              <div
                id="permit-application-process"
                className="sub-head fw-bold my-4"
              >
                6. Permit Application Process
              </div>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Compile the following: A: Permit applicant contact information. B: Contractor contact information, proposal, and license. PDF of plans, specifications, or documents, basic information for the project, including the cost of construction minus any site development costs.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                From your web-enabled phone, tablet, laptop, or computer, navigate to:{" "}
                <a
                  href="https://permits.pingreegrove.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://permits.pingreegrove.org/
                </a>
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Once on the landing page, familiarize yourself with the information relayed, including contact information for software support or customer service.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Select the role of Applicant/Contractor by clicking either the text or photo. Once completed, you will be automatically directed to start the process by entering basic permit applicant contact information. Also, in the Comment area, relay any questions or comments you may have specific to the proposed project.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Once all information is entered, click the green <strong>"Next"</strong> in the bottom right corner, and you will be automatically directed to the Contractor information page. When there, fill out basic contractor information and upload contractor documents &amp; contractor license in PDF format at the bottom of the page by clicking the blue browse text or by dragging the PDF manually.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                If there are multiple contractors, please follow the same process by clicking the green <strong>"Add Contractor tab"</strong> at the left side of the screen. Once complete, click the green <strong>"Next"</strong> button. If you want to verify the information entered, select the green <strong>"Previous"</strong> button tab instead of <strong>"Next"</strong>.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Once <strong>"Next"</strong> is selected, you will be automatically directed to the Proposed Work Location page. Once there, please enter the work location address on the left of the screen. If you do not have an address assigned yet, please note in this area <strong>TBD -</strong> followed by the Kane County Parcel Identification Number.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Under <strong>Commercial Permit Type</strong>, please click the drop-down menu and select your applicable permit type.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                In the <strong>Work Description</strong> area, enter a complete description of what is being proposed to be completed and what trades are applicable.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                In the <strong>Cost of Construction</strong> area, enter the total cost of construction, which does not include applicable site development costs, including but not limited to, building access roads, land acquisition, and grading work.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Upload construction documents, plans, or specifications in PDF format at the bottom of the page by clicking the blue browse text or by dragging the PDF manually. Once complete, click the green <strong>"Next"</strong> button at the bottom right corner, and you will be automatically directed to review the User Terms.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Once reviewed and acknowledged, click the green <strong>"Submit"</strong> button at the bottom right of the page. You will be automatically directed to the final Acknowledgement step, where you will have the option to complete the initial user process. Please note that if you select <strong>"No,"</strong> you will need to start the entire process over.
              </p>
              <p className="mb-3" style={{ textAlign: "justify" }}>
                Once reviewed and acknowledged, click the green <strong>"Yes, Submit"</strong> button, and the initial user process is completed. Once completed, confirmation will show on the screen with information.
              </p>
              <p className="mb-0" style={{ textAlign: "justify" }}>
                A confirmation email will be sent to the permit applicant's email. Once the plan review is complete, notice will be sent to the permit applicant's email. Once all applicable plan review comments have been addressed, Village requirements have been met, and fees have been paid, final approval with permit card will be sent to the permit applicant's email.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default UserGuide;

